import React from "react";
import { Link } from "@reach/router";
import { WithPrevState } from "@utils/data";
import { useReturnToSelfState } from "@utils/navigation";
import { PlaceHeaderButtonProps } from "./index.interface";

/**
 * @author Samuel Pelletier
 * @copyright (c) 2023 Cube Noir
 * Bouton d'interface de menu dans l'entête d'une sphere 360
 * (Ou menu Mobile)
 */
function PlaceHeaderButton({
  lang,
  title,
  linkTo,
  btnClass,
  txtFound,
  itemsFound,
  itemsTotal,
  onClick
}: PlaceHeaderButtonProps) {
  const returnToSelf: WithPrevState = useReturnToSelfState();
  const pcVal = Math.round((itemsFound / itemsTotal) * 100);
  const debugVal = `<p class='screen-reader-only'>${itemsFound}/${itemsTotal}</p>`;

  return (
    <Link to={linkTo} state={returnToSelf} className={btnClass} data-lang={lang} onClick={onClick}>
      <span className="titre">{title}</span>
      <div className="progres">
        <span
          className="detail"
          dangerouslySetInnerHTML={{
            __html: `<span>${pcVal}%</span> <span>${txtFound}</span>${debugVal}`
          }}
        />
        <div className="barre">
          <span className="progress" style={{ width: `${pcVal}%` }} />
        </div>
      </div>
    </Link>
  );
}

export default PlaceHeaderButton;
